import React from 'react';
import { DefaultOption } from 'src/components/molecules/DropdownSelect/components/DropdownOptions';
import { renderDropdownField } from './shared';
import { BaseInputProps } from './types';

export const DropdownSingleInput: React.FC<BaseInputProps> = ({
  currentQuestion,
  answers,
  dispatch,
  dropdownPlaceholder,
}) => {
  /* 'other' option temporarily commented: VAULT-18920 */
  // Filter out "other" options from dropdown
  const dropdownOptions =
    currentQuestion?.options
      ?.filter((opt) => !opt.isOtherOption)
      .map((opt) => ({
        label: opt.text,
        value: opt.id,
      })) || [];

  return renderDropdownField({
    options: dropdownOptions,
    value: answers[currentQuestion.id]?.singleDropdownOption || null,
    onChange: (value) =>
      dispatch({
        type: 'SET_SINGLE_DROPDOWN',
        questionId: currentQuestion.id,
        payload: value as DefaultOption | null,
      }),
    placeholder: dropdownPlaceholder,
    testId: 'form-preview-dropdown-single',
  });
};
